import {CacheItem} from "./CacheItem";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {concatMap, from, Observable, of, shareReplay, switchMap, tap} from "rxjs";
import {lastMap} from "../../rxjs/lastMap";
import {catchError, map} from "rxjs/operators";
import {retryWithBackoff} from "../../rxjs/retryWithBackoff";
import * as xml2js from 'xml2js'
import {Log, LogTag} from "../Log";
import {CachingService} from "./caching.service";

export class CacheDBPlayer extends CacheItem {
    businessDomain: string;
    businessId: number;
    table;
    id;
    data: any;
    modified: boolean = false;

    constructor(cachingService: CachingService, httpClient: HttpClient, businessDomain: string, businessId: number, table: string, id) {
        const url1 = 'https://' + businessDomain + '/Web/loadCachedData.ashx?businessId=' + businessId + '&table=' + table + '&id=' + id;
        super(cachingService, httpClient, url1, 'db', null);
        this.businessDomain = businessDomain;
        this.businessId = businessId;
        this.table = table;
        this.id = id;
    }

    request(expiration: number): Observable<any> {
        const logInfo = Log.getLogInfo("CacheDBPlayer", "request", [this.table, this.id]);
        if (this.data != null) {
            this.data.updated = false;
            Log.d(logInfo, LogTag.CACHE, 'return this.data');
            return of(this.data);
        }
        const url1 = 'https://' + this.businessDomain + '/Web/loadCachedData.ashx?businessId=' + this.businessId + '&table=' + this.table + '&id=' + this.id;

        this.cachingService.updateLastUsed('db', url1)
        return from(caches.match(url1)).pipe(
            switchMap(cachedResponse => {
                if (cachedResponse) {  // data exist in the cache
                    // get record from caching
                    return from(cachedResponse.json()).pipe(
                        lastMap(data1 => {
                            Log.d(logInfo, LogTag.CACHE, "data exist in the cache. data1=" + JSON.stringify(data1));
                            // if changelist_id in DB is the same as the one in the cache, then it will return minimal data (not include the player_data_value)
                            let url2 = 'https://' + this.businessDomain + '/Web/loadCachedData.ashx?businessId=' + this.businessId + '&table=' + this.table + '&id=' + this.id + '&changelistId=' + data1.changelist_id;
                            return new Observable<any>(sub2 => {
                                fetch(url2).then(response2 => {
                                    if (response2.status == 200) {
                                        response2.json().then(data2 => {
                                            Log.d(logInfo, LogTag.CACHE, "get data from server. data2: " + JSON.stringify(data2));
                                            if (data1.changelist_id == data2.changelist_id) {
                                                Log.d(logInfo, LogTag.CACHE, 'data was not changed');
                                                caches.open('db').then(cache => {
                                                    const headers = new Headers(cachedResponse.headers);
                                                    //const now = new Date().getTime();
                                                    //headers.set('last-used', now.toString());
                                                    const body = JSON.stringify(data1);
                                                    cache.put(url1, new Response(body, {
                                                        status: 200,
                                                        statusText: '',
                                                        headers: headers
                                                    })).then(a => {
                                                        Log.d(logInfo, LogTag.CACHE, 'DB update last-used!!! ' + url1);
                                                        data1.updated = false;
                                                        sub2.next(data1);
                                                        sub2.complete();
                                                    })
                                                })
                                            } else {
                                                Log.d(logInfo, LogTag.CACHE, 'data was changed');
                                                caches.open('db').then(cache => {
                                                    const headers = new Headers();
                                                    this.cachingService.updateLastUsed(this.folder, this.url);

                                                    const body = JSON.stringify(data2);
                                                    cache.put(url1, new Response(body, {
                                                        status: 200,
                                                        statusText: '',
                                                        headers: headers
                                                    })).then(a => {
                                                        Log.d(logInfo, LogTag.CACHE, 'update cache data');
                                                        data2.updated = true;
                                                        sub2.next(data2);
                                                        sub2.complete();
                                                    })
                                                })
                                            }
                                        })
                                    } else {
                                        console.log('response status:' + response2.status);
                                        sub2.next(data1);
                                        sub2.complete();
                                    }
                                }).catch(error => {
                                    Log.d(logInfo, LogTag.CACHE, "fetch fail");
                                    sub2.next(data1);
                                    sub2.complete();
                                })
                            })
                        })
                    )
                } else { // data not exist in the cache
                    Log.d(logInfo, LogTag.CACHE, 'data not exist in the cache');
                    return this.fetchDB(url1);
                }
            }),
            map(data => {
                if (data != null) {
                    if (this.table == "scenes") {
                        const myXML = (<any>data).player_data_value;
                        xml2js.parseString(myXML, (err, result) => {
                            (<any>data).json = result;
                            delete (<any>data).player_data_value;
                        });
                    }
                }
                this.data = data;
                return data;
            })
        )
    }

    fetchDB(url: string): Observable<any> {
        const self = this;
        const logInfo = Log.getLogInfo("CacheDBPlayer", "fetchDB", [this.table, this.id]);
        return new Observable<any>(sub3 => {
            fetch(url).then(function (response) {
                caches.open('db').then(cache => {
                    const copy = response.clone();
                    const headers = new Headers(copy.headers);
                    self.cachingService.updateLastUsed('db', url);

                    Log.d(this, LogTag.CACHE, 'DB FETCH (new) !!!!! ' + url);
                    return copy.json().then(data => {
                        const body = JSON.stringify(data);
                        if (body == '{}') {
                            Log.w(this, LogTag.CACHE, "resource was deleted from the DB");
                            sub3.next(null);
                            sub3.complete();
                        } else {
                            const newResponse = new Response(body, {
                                status: copy.status,
                                statusText: copy.statusText,
                                headers: headers
                            })
                            cache.put(url, newResponse).then(a => {
                                Log.w(logInfo, LogTag.CACHE, "resource was added");
                                sub3.next(data);
                                sub3.complete();
                            });
                        }
                    });
                })
            }).catch(error => {
                Log.w(logInfo, LogTag.CACHE, "fetch fail");
                sub3.error('fetch fail !!');
            })
        }).pipe(
            retryWithBackoff(),
            lastMap(data3 => {
                Log.d(logInfo, LogTag.CACHE, "new data was added. data3=" + data3);
                if (data3 != null) {
                    data3.updated = true;
                    Log.d(logInfo, LogTag.CACHE, "changelist_id 3: " + data3.changelist_id);
                }
                return of(data3);
            }),
            catchError(err => {
                Log.w(logInfo, LogTag.CACHE, "fetchDB, retryWithBackoff fail")
                return of(null);
            })
        )
    }
}
